import { FunctionalComponent } from 'preact';
import { Icon } from '../Icon/icon';

export interface ITogglerProps {
  onClick: Function;
}

export const Toggler: FunctionalComponent<ITogglerProps> = ({ onClick }) => (
  <div class="cw-toggler" onClick={() => onClick()}>
    <Icon class="cw-toggler__icon" icon="comments" />
  </div>
);
